import { lazy } from "react";
import Loadable from "components/Loadable.tsx";

const MemberTypeWiseMaterialTypeConfigList = Loadable(
  lazy(
    () => import("features/memberTypeWiseMaterialTypeConfig/components/List")
  )
);
const MemberTypeWiseMaterialTypeConfigPage = Loadable(
  lazy(
    () => import("features/memberTypeWiseMaterialTypeConfig/components/Page")
  )
);

const routes = {
  path: "memberTypewiseMaterialTypeConfig",
  children: [
    { path: "", element: <MemberTypeWiseMaterialTypeConfigList /> },
    { path: "add", element: <MemberTypeWiseMaterialTypeConfigPage /> },
    {
      path: "edit/:memberTypeWiseMaterialTypeConfigID?",
      element: <MemberTypeWiseMaterialTypeConfigPage />,
    },
  ],
};

export default routes;
